import { useCallback } from 'react';
import { useHistory as useDefaultHistory } from 'react-router-dom';

const searchParams = new URLSearchParams(window.location.search);

const useHistory = () => {
  const history = useDefaultHistory();

  const updateSearchParams = useCallback(
    (key, value) => {
      const params = new URLSearchParams(window.location.search);
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
      const url = `${window.location.pathname}?${params.toString()}`;
      history.push(url);
    },
    [history],
  );

  return { searchParams, updateSearchParams };
};

export default useHistory;
